<template>
  <v-data-table
    :headers="headers"
    :items="list"
    item-key="_id"
    class="elevation-0"
  >
    <template slot="items" slot-scope="props">
      <tr>
        <td
          v-for="(head, idx) in headers"
          :key="head.value"
          :align="idx === headers.length - 1 ? 'center' : 'left'"
        >
          <div v-if="idx < headers.length - 1">
            {{ props.item[head.value] }}
          </div>
          <v-btn
            v-if="idx === headers.length - 1"
            color="primary"
            small
            @click="$emit('onAction', props.item)"
            >{{ action }}</v-btn
          >
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    headers: {
      type: Array,
      default: function() {
        return [];
      }
    },
    action: {
      type: String,
      default: "Select"
    }
  }
};
</script>

<style></style>
